import { Component, Input, OnInit } from '@angular/core';
import { faUser, IconDefinition } from '@fortawesome/pro-duotone-svg-icons';
import { Store } from '@ngxs/store';
import _ from 'lodash';
import { SamwinUserConfigurationState } from 'src/app/store/samwin/samwin-user-configuration/samwin-user-configuration.state';
import { SamwinUserShortInfoRemoteDto } from 'src/generated/signalR/samwin-user-short-info-remote-dto';

@Component({
   selector: 'samweb-user-short-info',
   templateUrl: './user-short-info.component.html',
   styleUrls: ['./user-short-info.component.scss'],
})
export class UserShortInfoComponent implements OnInit {
   @Input()
   public userShortInfo: SamwinUserShortInfoRemoteDto;

   @Input()
   public userId: number;

   public userIcon: IconDefinition = faUser;

   constructor(private store: Store) {}

   ngOnInit(): void {
      if (!_.isNil(this.userId)) {
         this.userShortInfo = this.store.selectSnapshot(SamwinUserConfigurationState.getUserConfigurationFn)(this.userId);
      }
   }
}
